import { Alert, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { lime } from '@mui/material/colors'
import { formatarBRL } from '@/lib/formato'
import type { TaxaServicoTotem } from './use-taxa-servico-totem'
import PercentIcon from '@mui/icons-material/Percent'

export default function TaxaServicoCard({ taxa }: { taxa: TaxaServicoTotem }): JSX.Element | null {
    const { taxaServico, dispensada } = taxa
    if (taxaServico <= 0 && !dispensada) return null

    return (
        <Alert
            icon={<PercentIcon />}
            sx={(theme) => {
                const corPrincipal = dispensada
                    ? theme.palette.text.secondary
                    : theme.palette.mode === 'dark'
                        ? lime[400]
                        : lime[800]

                return {
                    width: '100%',
                    borderRadius: 2,
                    backgroundColor: alpha(corPrincipal, 0.1),
                    '& .MuiAlert-icon': { color: corPrincipal, opacity: dispensada ? 0.6 : 1 },
                    '& .MuiAlert-message': { width: '100%' },
                }
            }}
        >
            {dispensada ? (
                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                    <strong>Taxa de serviço não incluída.</strong> Você optou por não pagar a taxa de serviço.
                </Typography>
            ) : (
                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                    Este pedido possui uma taxa de serviço de{' '}
                    <strong style={{ color: 'inherit' }}>{formatarBRL(taxaServico)}</strong> distribuída em seus itens.
                    Ela é opcional e destinada à equipe de atendimento.
                </Typography>
            )}
        </Alert>
    )
}
